import { useIntl } from "react-intl";

type Props = {
	contentId?: string;
	defaultId?: string;
	defaultValue?: string;
};

export const useContent = ({ contentId, defaultId, defaultValue }: Props) => {
	let defaultMessage = "";
	const intl = useIntl();
	if (defaultValue) {
		defaultMessage = defaultValue;
	} else if (defaultId) {
		defaultMessage = intl.formatMessage({ id: defaultId });
	}

	return contentId ? intl.formatMessage({ id: contentId, defaultMessage: defaultMessage }) : defaultMessage;
};
